import { DND_ITEM_TYPES } from './constants';
import { DragItem, SortableData } from './types';

const dragItemTypes: string[] = Object.values(DND_ITEM_TYPES);

const isRecord = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null;

export const isDragItem = (v: unknown): v is DragItem =>
  isRecord(v) &&
  typeof v.itemType === 'string' &&
  dragItemTypes.includes(v.itemType) &&
  'props' in v;

export const isSortableData = (v: unknown): v is SortableData =>
  isRecord(v) &&
  typeof v.itemType === 'string' &&
  dragItemTypes.includes(v.itemType) &&
  (v.onSort === undefined || typeof v.onSort === 'function') &&
  (v.onDrop === undefined || typeof v.onDrop === 'function') &&
  (v.isDroppable === undefined || typeof v.isDroppable === 'boolean') &&
  'children' in v &&
  'props' in v;
